"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OidcUrlHelper = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _OidcTokenStorage = require("./storage/OidcTokenStorage");
class OidcUrlHelper {
  constructor() {
    (0, _defineProperty2.default)(this, "storage", new _OidcTokenStorage.OidcTokenStorage());
    (0, _defineProperty2.default)(this, "storeAuthCodeFromParams", params => {
      this.validateParams(params);
      const authCode = params.get(OidcUrlHelper.AUTH_CODE);
      if (authCode === null) {
        throw new Error(`Auth - missing authorization code`);
      }
      this.storage.authorizationCode.set(authCode);
      this.storage.state.remove();
      this.storage.nonce.remove();
    });
    (0, _defineProperty2.default)(this, "handleRedirectAfterLogin", () => {
      const redirectUrl = this.storage.redirectUrl.get();
      this.storage.redirectUrl.remove();
      if (typeof redirectUrl === 'string') {
        window.location.href = redirectUrl;
      }
    });
    (0, _defineProperty2.default)(this, "validateParams", params => {
      const errorParam = params.get('error');
      const stateParam = params.get('state');
      if (errorParam !== null) {
        throw new Error(`Auth - ${errorParam}`);
      }
      if (stateParam !== this.storage.state.get()) {
        throw new Error(`Auth - incorrect state`);
      }
    });
  }
}
exports.OidcUrlHelper = OidcUrlHelper;
(0, _defineProperty2.default)(OidcUrlHelper, "AUTH_CODE", 'code');
